<template>
  <transition name="fade">
    <div
      class="absolute fit column items-center justify-center text-grey-8 tl-lock-mask"
    >
      <q-icon name="fas fa-lock" size="1.4rem" class="q-mb-md" />
      <span> {{ lockTip || "已锁定" }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    lockTip: {
      type: String,
    },
  },
};
</script>

<style lang="scss">
.tl-lock-mask {
  background-color: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(12px) saturate(180%);
  left: 0;
  top: 0;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
